import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';

import type { CrmSearchAccountsReturn, Crm } from '../../../domain/crm';
import { crmApi } from '../api';

const ACCOUNTS_PER_PAGE = 10;

export const useCrmSearchAccountsQuery = ({
  searchText,
  crm,
  enabled = true,
}: {
  searchText: string;
  crm: Crm;
  enabled?: boolean;
}): UseInfiniteQueryResult<InfiniteData<CrmSearchAccountsReturn>> => {
  return useInfiniteQuery({
    queryKey: ['crm-search-accounts', searchText, crm],
    queryFn: ({ pageParam }) => {
      return crmApi.searchAccounts({
        after: pageParam,
        limit: ACCOUNTS_PER_PAGE,
        searchText,
        crm,
      });
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => (lastPage.data.length === ACCOUNTS_PER_PAGE ? lastPage.next.after : undefined),
    enabled,
  });
};
